import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"

import {
  Box,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormControl,
  Typography,
} from "@mui/material"
export default function CertificationTab({
  localProject,
  setLocalProject,
  setBaseCertTouched,
  canChangeBaseCert,
}) {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        {i18n.t("editProject.columntToCert")}:
      </Typography>
      <FormControl
        component="fieldset"
        margin="normal"
        disabled={!canChangeBaseCert}
      >
        <RadioGroup
          value={localProject.base_cert || "client"}
          onChange={e => {
            setBaseCertTouched(true)
            setLocalProject(lp => ({
              ...lp,
              base_cert: e.target.value,
            }))
          }}
        >
          <FormControlLabel
            value="client"
            control={<Radio />}
            label={i18n.t("editProject.clientPrice")}
          />
          <FormControlLabel
            value="cost"
            control={<Radio />}
            label={i18n.t("editProject.objetiveCost")}
          />
        </RadioGroup>
      </FormControl>
    </Box>
  )
}

CertificationTab.propTypes = {
  localProject: PropTypes.object.isRequired,
  setLocalProject: PropTypes.func.isRequired,
  setBaseCertTouched: PropTypes.func.isRequired,
  canChangeBaseCert: PropTypes.bool.isRequired,
}
